import { FriendInterface, FRIEND_STATUS } from './../../interfaces/FriendInterface';
import {
  GET_FRIENDS
} from '../constants/index'
import Api from '../../services/Api'

const api = Api.getInstance();

export const getFriendsAction = (payload: any) => {
	return {
		type: GET_FRIENDS,
		payload
	}
}

export const getFriends = () => (dispatch: any) => {
  if(api.loggedIn) {
    api.get('friends').then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          dispatch(getFriendsAction(resultJson))
        }
      });
    });
  }
}

export const isBlacklisted = (friendId: number, blacklist: any) => {
  for (const blacklisted of blacklist) {
    if (blacklisted.id === friendId) {
      return true
    }
  }
  return false
}

export const blockUnblockAction = (friendId: number, blacklist: any) => (dispatch: any) => {
  return new Promise(resolve => {
    const blacklisted = isBlacklisted(friendId, blacklist)
    const doBlock = blacklisted ? 0 : 1
    api.get('friend_blacklist/' + friendId + '/' + doBlock).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          api.get('friends').then(result => {
            result.json().then(resultJson => {
              if (resultJson.status === 'ok') {
                dispatch(getFriendsAction(resultJson))
                resolve(true)
              }
            })
          });
        } else {
          resolve(false)
        }
      });
    });
  })
}

export const answerFriendRequest = (friend: FriendInterface, status: FRIEND_STATUS) => (dispatch:any) =>  {
  api.get('friend_reply_request/' + friend.friendId + '/' + status).then(result => {
    result.json().then(resultJson => {
      if (resultJson.status === 'ok') {
        getFriends()
      }
    });
  });
}

